import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonShape, ButtonSize, ButtonVariant } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { useDispatch, useSelector } from 'react-redux';
import AddToWishlistButton from '../../components/product-detail/add-to-wishlist-button/AddToWishlistButton';
import ProductPreview from '../../components/product-detail/product-preview/ProductPreview';
import { makeGetProductDefaults, makeGetSelectedColorId, makeGetSelectedSku, } from '../../redux/product/selectors/ProductSelector';
import { productPreviewActions } from '../../redux/productPreview/actions/ProductPreviewActions.creators';
import { makeGetShowImageTouchZoomHint } from '../../redux/productPreview/selectors/ProductPreviewSelectors';
import { wishListActions } from '../../redux/wishList/actions/WishListActions.creators';
import { makeGetProductColorIsInWishList } from '../../redux/wishList/selectors/WishListSelectors';
export const ProductPreviewContainer = () => {
    const { isShopLanding } = useAemConfig();
    const selectedColorId = useSelector(makeGetSelectedColorId());
    const showImageTouchZoomHint = useSelector(makeGetShowImageTouchZoomHint());
    const dispatch = useDispatch();
    const selectedSku = useSelector(makeGetSelectedSku());
    const { productCode, productId } = useSelector(makeGetProductDefaults());
    const productColorIsInWishList = useSelector(makeGetProductColorIsInWishList());
    const wishListProduct = {
        colorId: selectedColorId,
        productCode: productCode,
        productId: parseInt(productId, 10),
        sku: selectedSku,
    };
    const handleToggleWishlist = () => {
        dispatch(wishListActions.toggleProduct(wishListProduct));
    };
    const handleImageTouchZoom = () => {
        dispatch(productPreviewActions.disableImageTouchZoomHint());
    };
    return (_jsxs(_Fragment, { children: [_jsx(ProductPreview, { productId: productId, selectedColorId: selectedColorId, showImageTouchZoomHint: showImageTouchZoomHint, onImageTouchZoom: handleImageTouchZoom }), !isShopLanding && (_jsx(AddToWishlistButton, { isProductInWishList: productColorIsInWishList, onToggle: handleToggleWishlist, wishListProduct: wishListProduct, buttonProps: {
                    shape: ButtonShape.PILL,
                    variant: ButtonVariant.INVERSE_ALT,
                    size: ButtonSize.NORMAL,
                } }))] }));
};
